/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import { logger } from "../../../utils/logger";
import { EPF_REPORT_INITIAL_STATE } from "./epf-report-constant";

const useEPFReportService = () => {
    const [epfReportTableUILoading, setEpfReportTableUILoading] = useState(false);
    const [epfReportInputs, setEpfReportInputs] = useState(EPF_REPORT_INITIAL_STATE)
    const [EPFReportListData, setEPFReportListData] = useState([]);
    const { fetchData } = useAPIHandler()
    const [dataFetched, setDataFetched] = useState(false);
    const [loadingAllEPFReport, setLoadingAllEPFReport] = useState(false);
    const [epfReportPDFData, setEpfReportPDFData] = useState([]);
    const [epfReportSummary, setEpfReportSummary] = useState({})
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchQuery, setSearchQuery] = useState("")
    const [organizationInfo, setOrganizationInfo] = useState({})
    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }
        setEpfReportInputs((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }))
    }
    const { report_month } = epfReportInputs;
    let year, month
    if (report_month) {
        const parts = report_month.split("-");
        year = parts[0];
        month = parts[1];
        if (month.startsWith("0")) {
            month = month.substring(1);
        }
    }
    const fetchAllEPFReportEmpList = async () => {
        setEpfReportTableUILoading(true);
        try {
            if (report_month) {
                const url = `/report/epf?month=${month}&year=${year}&pageLimit=${rowsPerPage}&page=${currentPage + 1}&search=${searchQuery}`
                const response = await fetchData({
                    url: url,
                    method: 'GET',
                });
                setEPFReportListData(response?.data?.salary);
                logger.log(response, "EPFReportListData99")
                setTotalPages(response?.data?.pagesNumber);
            }
        } catch (error) {
            setEpfReportTableUILoading(false);
        }
    }
    const fetchAllEPFReportData = async () => {
        setLoadingAllEPFReport(true);
        try {
            if (report_month) {
                // const url =`/report/salary?month=${month}&year=${year}&order_type=ASC`
                const url = `/report/epf?month=${month}&year=${year}&order_type=ASC`
                const response = await fetchData({
                    url: url,
                    method: 'GET',
                });
                setEpfReportPDFData(response?.data?.salary);
                // extractAllowances(response?.data?.salary);
                setEpfReportSummary(response?.data?.additional_details)
                setOrganizationInfo(response?.data?.org_details)
                setDataFetched(true)
                logger.log(response?.data, "salaryReportListData99")

            }
            setLoadingAllEPFReport(false)
        } catch (error) {
            setLoadingAllEPFReport(false)
            logger.log(error);
        }

    }
    useEffect(() => {
        fetchAllEPFReportEmpList()
    }, [epfReportInputs,rowsPerPage, currentPage, searchQuery])
    const handleExportClick = async () => {
        await fetchAllEPFReportData();
    };
    useEffect(() => {
        handleExportClick()
    }, [epfReportInputs])
    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
    };

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    const handleRowsPerPageChange = (value) => {
        setRowsPerPage(Number(value.target.value));
        setCurrentPage(0);
    };
    return {
        EPFReportListData,
        epfReportInputs,
        handleChange,
        dataFetched,
        handleExportClick,
        loadingAllEPFReport,
        epfReportPDFData,
        epfReportSummary,
        rowsPerPage,
        currentPage,
        totalPages,
        handleNextPage,
        handlePreviousPage,
        handleRowsPerPageChange,
        searchQuery,
        setSearchQuery,
        organizationInfo
    }
}
export default useEPFReportService;